import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;
  background-color: ${props => props.theme.colors[props.bg] || props.bg};
`
